<div *ngIf="isEmptyData" class="message" [ngClass]="{'border': isBordered}">
  {{loading ? 'Fetching data...' : 'No data to display'}}
</div>
